import { ImageScaleView, ImageScaleViewOpts } from '@play-co/timestep-core/ui';
import LangBitmapFontTextView from 'src/lib/ui/components/LangBitmapFontTextView';
import i18n from 'src/lib/i18n/i18n';
import { getContinueRewardIcon, getRewardIcon } from '../match2.icons';
import { getMatch2ContinueConfig } from 'src/replicant/match2/match2.getters';
import { user } from 'src/StateObserver';
import { matchTheme } from 'src/game/theme/match2/Match2Theme';

export default class Match2PinchPanel extends ImageScaleView {
  constructor(
    opts: Omit<
      ImageScaleViewOpts,
      'image' | 'width' | 'height' | 'centerOnOrigin' | 'centerAnchor'
    > &
      (
        | { type: 'energy'; amount: number }
        | { type: 'moves'; amount: number; continues: number }
      ),
  ) {
    super({
      ...opts,
      width: 253,
      height: 213,
      centerOnOrigin: true,
      centerAnchor: true,
      image: 'assets/ui/match2/common/panel_pinch.png',
    });

    const useDoubleBadge = opts.type === 'moves' && opts.continues > 0;
    let offsetX = useDoubleBadge ? 52 : 0;

    new ImageScaleView({
      superview: this,
      image: `assets/ui/match2/common/pinch_${opts.type}.png`,
      width: 208,
      height: 217,
      centerOnOrigin: true,
      centerAnchor: true,
      x: this.style.width * 0.5 - offsetX,
      y: this.style.height * 0.5 - 20,
      scale: 0.55,
    });

    new LangBitmapFontTextView({
      superview: this,
      font: 'Title',
      color: '#FFFFFF',
      size: 45,
      x: this.style.width * 0.5 + 20 - offsetX,
      y: this.style.height * 0.5 - 20,
      centerOnOrigin: true,
      centerAnchor: true,
      localeText: () => `+${opts.amount}`,
      verticalAlign: 'center',
      align: 'center',
    });

    if (useDoubleBadge) {
      offsetX += 5;

      const panel = new ImageScaleView({
        superview: this,
        image: matchTheme().getUIAsset(`continue_bonus_panel.png`),
        width: 208,
        height: 217,
        centerOnOrigin: true,
        centerAnchor: true,
        x: this.style.width * 0.5 + offsetX,
        y: this.style.height * 0.5 - 14,
        scale: 0.45,
      });

      getContinueRewardIcon()
        ?.get()
        .then((image) => {
          new ImageScaleView({
            superview: panel,
            image,
            width: panel.style.width,
            height: panel.style.height,
          });
        });

      new LangBitmapFontTextView({
        superview: this,
        font: 'Title',
        color: '#FFB14A',
        size: 25,
        x: this.style.width * 0.5 + offsetX,
        y: 25,
        centerOnOrigin: true,
        centerAnchor: true,
        localeText: () =>
          i18n(`match2.${opts.type}Pinch.bonus`, {
            [opts.type]: opts.amount,
          }).toLocaleUpperCase(),
        verticalAlign: 'center',
        align: 'center',
      });

      if (opts.continues > 3) {
        new LangBitmapFontTextView({
          superview: this,
          font: 'Title',
          color: '#FFFFFF',
          size: 35,
          x: this.style.width * 0.5 + 20 + offsetX,
          y: this.style.height * 0.5 - 14,
          centerOnOrigin: true,
          centerAnchor: true,
          localeText: () => 'x2',
          verticalAlign: 'center',
          align: 'center',
        });
      }
    }

    new LangBitmapFontTextView({
      superview: this,
      font: 'Body',
      color: '#BF8147',
      size: 20,
      x: this.style.width * 0.5,
      y: 165,
      centerOnOrigin: true,
      centerAnchor: true,
      localeText: () =>
        i18n(`match2.${opts.type}Pinch.message`, { [opts.type]: opts.amount }),
      verticalAlign: 'center',
      align: 'center',
    });
  }
}
